<template>
  <div>

    <v-row>
      <v-col cols="12" class="pt-0">
        <template v-if="value.TipoContratoSigla && !showDesembolso">
          <v-subheader class="pa-0">Este produto permite os seguintes tipos de desembolso:</v-subheader>

          <input-radiogroup row v-model="model.TipoDesembolso" required name="Tipo Desembolso" @change="changeTipoDesembolso">
            <v-radio v-for="(item, i) in tiposDesembolso" :value="item.value" :key="i">
              <template slot="label">
                <span class="mr-2">{{item.name}}</span>
              </template>
            </v-radio>
          </input-radiogroup>
        </template>
        <template v-else-if="!showDesembolso">
          <v-col cols="12" class="pa-0">
            <v-alert border="left" text>
              Selecione o tipo de desembolso
            </v-alert>
          </v-col>
        </template>
      </v-col>
    </v-row>

    <template v-if="!!model.TipoDesembolso">
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-alert border="left" text color="primary">
            <template v-if="!permiteEditarBanco">
              O desembolso da proposta será efetuado na conta abaixo
            </template>
            <template v-else-if="model.TipoDesembolso === $api.Enums.TipoDesembolso.Emitente">
              Informe os dados bancários para desembolso no Emitente
            </template>
            <template v-else>
              Informe os dados para desembolso
            </template>
          </v-alert>
        </v-col>
      </v-row>

      <v-subheader>Dados do Beneficiário</v-subheader>
      <v-row v-if="contasDesembolso.length > 0 && model.TipoDesembolso === $api.Enums.TipoDesembolso.Outros">
        <v-col cols="12">
          <input-autocomplete
            required
            label="Beneficiário"
            item-text="textField"
            v-model="ContaDesembolso"
            return-object
            :items="contasDesembolso"
            @change="changeContaDesembolso"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <input-documento v-if="permiteEditarPessoa" label="CPF/CNPJ" v-model="model.DocumentoFederal" required />
          <input-text v-else label="CPF/CNPJ" :value="$api.UI.Format.DocumentoFederal(model.DocumentoFederal)" required disabled />
        </v-col>
        <v-col cols="8">
          <input-text :disabled="!permiteEditarPessoa" label="Nome/Razão Social" v-model="model.Nome" required />
        </v-col>
      </v-row>

      <v-subheader>Informações Bancárias</v-subheader>
      <v-row>
        <v-col v-if="errorAlert.show" cols="12">
          <v-alert text type="error">
            {{errorAlert.msg}}
          </v-alert>
        </v-col>
        <v-col cols="12" class="pa-0">
          <input-seleciona-banco required
            v-model="model.ContaPagamento"
            :disabled="!permiteEditarBanco"
          />
        </v-col>
        <v-col cols="12" class="pt-0">
          <input-radiogroup row v-model="model.ContaPagamento.TipoConta" :disabled="!permiteEditarBanco" @change="changeAgencia" required name="Tipo Conta">
            <v-radio :value="1">
              <template slot="label">
                <span class="mr-2">Conta poupança</span>
              </template>
            </v-radio>
            <v-radio :value="2">
              <template slot="label">
                <span class="mr-2">Conta corrente</span>
              </template>
            </v-radio>
            <v-radio :value="3">
              <template slot="label">
                <span class="mr-2">Conta pagamento</span>
              </template>
            </v-radio>
          </input-radiogroup>
        </v-col>
        <v-col cols="6">
          <input-text required
                      :disabled="!permiteEditarBanco || model.ContaPagamento.TipoConta === 3"
                      v-model="model.ContaPagamento.Agencia"
                      label="Agência" v-mask="['####','####-#']" />
        </v-col>
        <v-col cols="6">
          <input-text required
                      :disabled="!permiteEditarBanco"
                      v-model="model.ContaPagamento.Conta"
                      label="Conta"
                      v-mask="$api.UI.Format.MascaraDigito(15)"/>
        </v-col>

      </v-row>
    </template>
    <template v-if="showDesembolso && value.TipoContratoSigla">
      <v-col cols="12">
        <v-alert
          dense
          border="left"
          text
          type="warning"
        >
          O produto não possui opções de desembolso
        </v-alert>
      </v-col>
    </template>
    <modal-form :submit="save" size="md" text-submit="Confirmar" v-model="showConfirm">
      <template v-slot:title>
        Atenção
      </template>
      <template v-slot:body>
        <v-alert border="left" text color="primary">
          Os dados do desembolso foram alterados. Confirma a alteração?
        </v-alert>

        <v-row>
          <v-col cols="6">
            Dados anteriores
            <v-label>Beneficiário: </v-label> {{model.Nome}}
          </v-col>
          <v-col cols="6">Dados atuais</v-col>
        </v-row>
      </template>
    </modal-form>
  </div>
</template>

<script>
export default {
  props: {
    value: null
  },
  data () {
    return {
      bancos: [],
      model: {
        ContaPagamento: {}
      },
      errorAlert: { show: false, msg: '' },
      showConfirm: false,
      contasDesembolso: [],
      ContaDesembolso: null
    }
  },
  computed: {
    tiposDesembolso () {
      var lista = []
      if (this.value.TipoContratoSigla && this.$param.EST_DESEMBOLSO) {
        const tipos = this.$param.EST_DESEMBOLSO[this.value.TipoContratoSigla]
        if (tipos && tipos.length > 0) {
          lista = this.$api.Arrays.TipoDesembolso.filter(p => tipos.indexOf(p.value) >= 0)
        }
      }

      return lista
    },
    showDesembolso () {
      let validacao = false
      if (this.value.TipoContratoSigla && this.$param.EST_DESEMBOLSO) {
        const tipos = this.$param.EST_DESEMBOLSO[this.value.TipoContratoSigla]
        if (tipos && tipos.length <= 0) {
          validacao = true
        }
      }
      return validacao;
    },
    permiteEditarBanco () {
      return this.model.TipoDesembolso && (
        this.model.TipoDesembolso === this.$api.Enums.TipoDesembolso.Emitente ||
          (this.model.TipoDesembolso === this.$api.Enums.TipoDesembolso.Outros && this.contasDesembolso.length === 0)
      )
    },
    permiteEditarPessoa () {
      return this.model.TipoDesembolso && (this.model.TipoDesembolso === this.$api.Enums.TipoDesembolso.Outros && this.contasDesembolso.length === 0)
    },
  },
  methods: {
    load () {
      this.$set(this, 'model', { ContaPagamento: {} })
      this.loadContasDesembolso()
      if (this.value.TipoDesembolso) {
        this.$set(this.model, 'TipoDesembolso', parseInt(this.value.TipoDesembolso))
        this.changeTipoDesembolso(this.model.TipoDesembolso)
      }
    },
    changeAgencia () {
      const th = this
      if (th.model.ContaPagamento.TipoConta === 3) {
        th.$set(th.model.ContaPagamento, 'Agencia', '0001')
      } else {
        th.$set(th.model.ContaPagamento, 'Agencia', null)
      }
    },
    changeTipoDesembolso (tipo) {
      const th = this
      th.errorAlert.show = false
      th.$set(th.model, 'DocumentoFederal', null)
      th.$set(th.model, 'Nome', null)
      th.$set(th.model, 'ContaPagamento', {})
      th.$set(th, 'ContaDesembolso', null)
      switch (tipo) {
        case th.$api.Enums.TipoDesembolso.Emitente:
          th.$set(th.model, 'DocumentoFederal', th.value.Cliente.DocumentoFederal)
          th.$set(th.model, 'Nome', th.value.Cliente.Nome)
          th.loadPessoaData(th.value.Cliente.DocumentoFederal)
          th.loadPessoaBancoData(th.value.Cliente.Codigo)
          break
        case th.$api.Enums.TipoDesembolso.Portal:
          th.loadPessoaData(null, 'SelectPessoaIntegracao')
          break
        case th.$api.Enums.TipoDesembolso.Correspondente:
          th.loadPessoaData(th.$empresa.documentoFederal)
          break
        case th.$api.Enums.TipoDesembolso.Outros:
          if (th.value.Promotor && th.value.Promotor.Codigo) {
            th.$set(th.model, 'Codigo', th.value.Promotor.Codigo)
            th.$set(th.model, 'DocumentoFederal', th.value.Promotor.DocumentoFederal)
            th.$set(th.model, 'Nome', th.value.Promotor.Nome)
            th.loadPessoaData(th.value.Promotor.DocumentoFederal)
          }
          th.loadContasDesembolso()
          break
      }
    },
    loadPessoaData (documentoFederal, method) {
      const th = this
      if (!method) { method = 'SelectPessoa' }
      const promise = method === 'SelectPessoaIntegracao'
        ? th.$api.Multiplo.SelectPessoaIntegracao()
        : th.$api.Multiplo.SelectPessoa({ filter: { tipoRegistro: 1, DocumentoCliente: documentoFederal } })
      promise.then(function (pessoa) {
        if (th.$api.UI.PostLoadData(pessoa)) {
          pessoa = JSON.parse(pessoa.JSON)
          th.$set(th.model, 'Codigo', pessoa.Codigo)
          th.$set(th.model, 'DocumentoFederal', th.$api.UI.Format.DocumentoFederal(pessoa.DocumentoFederal))
          th.$set(th.model, 'Nome', pessoa.Nome)

          th.loadPessoaBancoData()
        }
      })
    },
    loadPessoaBancoData () {
      const th = this
      const tipoEnum = th.$api.Enums.TipoDesembolso
      if (th.model.Codigo) {
        const dto = { parameters: [{ name: 'CodigoPessoa', value: th.model.Codigo }] }
        th.$api.Multiplo.ListPessoaBanco(dto).then(pessoaBanco => {
          if (th.$api.UI.PostLoadData(pessoaBanco)) {
            pessoaBanco = pessoaBanco.Data
            if (pessoaBanco && pessoaBanco.length > 0) {
              pessoaBanco = pessoaBanco.sort(function (a, b) {
                return new Date(b.DtAlteracao) - new Date(a.DtAlteracao);
              });
            }
            if (!pessoaBanco || pessoaBanco.length === 0) {
              if (th.model.TipoDesembolso === tipoEnum.Portal || th.model.TipoDesembolso === tipoEnum.Correspondente) {
                th.errorAlert.show = true
                th.errorAlert.msg = 'Não existe conta de desembolso cadastrada no sistema para o tipo selecionado'
              }
              return
            }
            th.$set(th.model, 'ContaPagamento', pessoaBanco[0])
            th.$set(th.model.ContaPagamento, 'Banco', th.bancos.find(p => p.ID === pessoaBanco[0]?.CodigoBanco)?.Description)
            th.$set(th.model.ContaPagamento, 'Agencia', pessoaBanco[0]?.Agencia + (pessoaBanco[0]?.AgenciaDig ? '-' + pessoaBanco[0]?.AgenciaDig : ''))
            th.$set(th.model.ContaPagamento, 'Conta', pessoaBanco[0]?.Conta + (pessoaBanco[0]?.ContaDig ? '-' + pessoaBanco[0]?.ContaDig : ''))
            th.$set(th.model.ContaPagamento, 'TipoConta', pessoaBanco[0]?.TipoConta)
          }
        })
      }
    },
    submit () {
      const th = this
      /// / melhorar, usar modal em criado.
      // if (th.value.TipoDesembolso && th.value.TipoDesembolso !== th.model.TipoDesembolso) {
      //  th.$api.UI.Confirmacao('info', 'Os dados do desembolso foram alterados. Confirma a alteração?', function () {
      //    th.save()
      //  }, null, 'Atenção!')
      // } else {
      th.save()
      // }
    },
    save () {
      const th = this
      const response = {
        TipoDesembolso: th.model.TipoDesembolso,
        ContaPagamento: th.model.ContaPagamento
      }
      response.ContaPagamento.DocumentoFederal = th.model.DocumentoFederal
      response.ContaPagamento.Nome = th.model.Nome

      // Salvar PessoaBanco
      if (!th.model.TipoDesembolso) {
        th.$api.UI.ShowError(th.$getErrorMessage('desembolso').message)
      } else if (th.model.TipoDesembolso !== th.$api.Enums.TipoDesembolso.Outros) {
        th.atualizarPessoaBanco(response)
      } else {
        response.Promotor = {
          DocumentoFederal: th.model.DocumentoFederal,
          Nome: th.model.Nome
        }

        const dto = {
          DocumentoFederal: th.model.DocumentoFederal,
          Nome: th.model.Nome,
          PessoaDadosContato: {
            TelefoneFixo1: '0000000000'
          }
        }
        th.$api.Multiplo.CreateUpdatePessoa({ dto }).then(function (pessoa) {
          if (th.$api.UI.PostLoadData(pessoa, true)) {
            response.Promotor.Codigo = pessoa.Codigo
            th.atualizarPessoaBanco({ ...response, Identificador: th.ContaDesembolso?.Identificador })
          }
        })
      }
    },
    atualizarPessoaBanco (response) {
      const th = this
      const dtoBanco = {
        dto: {
          ...th.model.ContaPagamento,
          TipoConta: th.model.ContaPagamento.TipoConta,
          Agencia: th.model.ContaPagamento.Agencia.split('-')[0],
          AgenciaDig: th.model.ContaPagamento.Agencia.split('-')[1],
          Conta: th.model.ContaPagamento.Conta.split('-')[0],
          ContaDig: th.model.ContaPagamento.Conta.split('-')[1]
        },
        param: { DocumentoCliente: th.model.DocumentoFederal }
      }

      th.$api.Multiplo.CreateUpdatePessoaBanco(dtoBanco).then(function (pessoaBanco) {
        if (th.$api.UI.PostLoadData(pessoaBanco, true)) {
          th.$emit('response', response)
        }
      })
    },
    loadContasDesembolso () {
      const dto = {
        Referenciador: 'ContasDesembolso',
        CodigoPortal: this.$empresa.codigoPortal
      }
      this.$api.ItemsCustomizados.ListReferenciaByPortalAndStatus(dto).then((result) => {
        this.$data.contasDesembolso = result.map(item => {
          const obj = JSON.parse(item.valorItem)
          const textField = `${obj.Identificador} - ${obj.Nome} - ${obj.DocumentoFederal}`;
          return {
            ...obj,
            textField
          };
        })
        const conta = this.contasDesembolso.find(c => c.Identificador === this.value.Identificador)
        this.$set(this, 'ContaDesembolso', conta)
      })
    },
    changeContaDesembolso (item) {
      const th = this
      th.$set(th.model, 'DocumentoFederal', item.DocumentoFederal)
      th.$set(th.model, 'Nome', item.Nome)
      th.$set(th.model.ContaPagamento, 'TipoConta', parseInt(item.TipoConta))
      th.$set(th.model.ContaPagamento, 'Agencia', `${th.formatString(item.Agencia, 4)}`)
      th.$set(th.model.ContaPagamento, 'Conta', `${th.formatString(item.Conta, 13)}`)
      const banco = th.bancos.find(banco => banco.Code === item.NumeroBanco)
      th.$set(th.model.ContaPagamento, 'CodigoBanco', banco.ID)
      th.$set(th.model.ContaPagamento, 'Banco', banco.Description)
      th.$set(th.model.ContaPagamento, 'NroBanco', banco.Code)
    },
    formatString (inputNumber, size) {
      if (inputNumber === null || inputNumber === undefined) return '';

      const str = String(inputNumber).trim();

      if (str.includes('-')) {
        const parts = str.split('-', 2);
        const leftDigits = (parts[0] || '').replace(/\D/g, '').padStart(size, '0').slice(-size);
        const rightRaw = (parts[1] || '').replace(/\D/g, '');
        const rightDigit = rightRaw ? rightRaw.charAt(0) : '0';
        return `${leftDigits}-${rightDigit}`;
      }

      const onlyDigits = str.replace(/\D/g, '');
      if (onlyDigits.length === 0) return '';

      if (onlyDigits.length <= size) {
        const left = onlyDigits.padStart(size, '0');
        return `${left}-0`;
      }

      const left = onlyDigits.slice(0, size);
      const right = onlyDigits.charAt(size) || '0';
      return `${left}-${right}`;
    }
  },
  created () {
    const th = this;
    th.$api.Multiplo.Select({ filter: { tipoRegistro: 201 } }).then(
      function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          if (response.Result) {
            try {
              th.bancos = JSON.parse(response.JSON);
            } catch { }
          }
        }
      })
  }
}
</script>
